"use client";

import { c as _c } from "react/compiler-runtime";
import { useDesktopAnimations } from "@/lib/breakpoints";
import React from "react";
import Image from "next/image";
import { motion } from "framer-motion";
import GradientButton from "@/components/ui/GradientButton";
import { FaChevronRight } from "react-icons/fa";
const ease = [0.17, 0.85, 0.438, 0.99] as const;
export default function MultiDoctorSection() {
  const $ = _c(15);
  const desktopAnimations = useDesktopAnimations();
  let t0;
  if ($[0] !== desktopAnimations) {
    t0 = desktopAnimations ? {
      opacity: 0,
      y: 40
    } : false;
    $[0] = desktopAnimations;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== desktopAnimations) {
    t1 = desktopAnimations ? {
      opacity: 1,
      y: 0
    } : undefined;
    $[2] = desktopAnimations;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== desktopAnimations) {
    t2 = desktopAnimations ? undefined : {
      opacity: 1,
      y: 0
    };
    $[4] = desktopAnimations;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      duration: 0.7,
      ease
    };
    t4 = {
      once: true,
      amount: 0.25
    };
    $[6] = t3;
    $[7] = t4;
  } else {
    t3 = $[6];
    t4 = $[7];
  }
  let t5;
  let t6;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <h2 className="mb-4 font-poppins text-[1.6rem] md:text-[2rem] font-bold leading-[1.25] text-[#0b2545] dark:text-white">Handling multiple doctors? Our solution simplifies management effortlessly</h2>;
    t6 = <p className="mb-8 text-[#5b6b7d] text-base leading-relaxed dark:text-gray-300">Access dedicated front-desk software tailored to meet your specific needs.</p>;
    $[8] = t5;
    $[9] = t6;
  } else {
    t5 = $[8];
    t6 = $[9];
  }
  let t7;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className="flex flex-col items-center gap-10 lg:flex-row lg:justify-between"><div className="max-w-[560px] text-center lg:text-left">{t5}{t6}<GradientButton href="/contact" variant="peach-pink">Book A Demo <FaChevronRight className="ml-1 text-[12px]" /></GradientButton></div><Image src="/images/appointment/multiple-doctors.png" alt="Managing multiple doctors" width={420} height={380} className="h-auto w-full max-w-[420px] object-contain" /></div>;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t0 || $[12] !== t1 || $[13] !== t2) {
    t8 = <section className="bg-white py-16 md:py-24 px-6 font-sans overflow-hidden dark:bg-gray-950"><div className="max-w-7xl mx-auto"><motion.div initial={t0} whileInView={t1} animate={t2} transition={t3} viewport={t4} className="overflow-hidden rounded-[24px] bg-gradient-to-b from-[#c7ecff] to-[#f9efff] px-6 py-10 md:px-12 md:py-12 dark:from-gray-900 dark:to-gray-800">{t7}</motion.div></div></section>;
    $[11] = t0;
    $[12] = t1;
    $[13] = t2;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  return t8;
}